import Icon from '../components/Icon.vue'

Icon.register({
  'eye-dropper': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M50.8 333.3C38.8 345.3 32 361.5 32 378.5V424L0 480 32 512 88 480H133.5C150.5 480 166.7 473.3 178.7 461.3L305.4 334.6 177.4 206.6 50.8 333.3zM483.9 28.1C446.4-9.4 385.6-9.4 348.1 28.1L271 105.2 257.9 92.1C248.5 82.7 233.3 82.8 224 92.1L183 133.1C173.7 142.4 173.7 157.6 183 167L345 329C354.4 338.4 369.6 338.3 378.9 329L419.9 288C429.3 278.6 429.3 263.4 419.9 254.1L406.8 241 483.9 163.9C521.4 126.4 521.4 65.6 483.9 28.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/eye-dropper.js
// module id = slV7
// module chunks = 144